<div class="details-wrapper">
  <a
    class="show-details-link"
    (click)="showDetails = !showDetails"
    (keydown.enter)="showDetails = !showDetails"
    tabindex="0"
    role="button"
    [attr.aria-expanded]="showDetails"
  >
    <span i18n="@@basketPanelTotalShowDetails">Show details</span>
    <span class="sr-only">
      for {{ flightDetails?.marketingCarrier }}{{ flightDetails?.marketingFlightNumber }}</span
    >
    <i
      class="ico"
      [class.ico-chevron-down]="!showDetails"
      [class.ico-chevron-up]="showDetails"
      aria-hidden="true"
    ></i>
  </a>
  @if (showDetails) {
    <div class="summary">
      <dl class="details-grid">
        <!-- Row 1: Terminal | Hold Baggage -->
        @if (flightDetails?.originTerminal) {
          <div class="details-grid__item">
            <dt><strong i18n="@@ParkingSearchTerminal">Terminal</strong>:</dt>
            <dd>{{ flightDetails.originTerminal }}</dd>
          </div>
        }
        @if (flightDetails?.baggageAllowanceAmount !== undefined) {
          <div class="details-grid__item">
            <dt><strong i18n="@@ShowDetailsHoldBaggage">Hold baggage</strong>:</dt>
            <dd>
              {{ flightDetails?.baggageAllowanceAmount }}
              @if (flightDetails?.baggageAllowanceAmount > 1) {
                <span i18n="@@bags">bags</span>
              } @else {
                <span i18n="@@bag">bag</span>
              }
            </dd>
          </div>
        }
        <!-- Row 2: Flight number | Hand Baggage -->
        <div class="details-grid__item">
          <dt><strong i18n="@@pnlSearchFlightNumber">Flight number:</strong></dt>
          <dd>{{ flightDetails?.marketingCarrier }}{{ flightDetails?.marketingFlightNumber }}</dd>
        </div>
        <div class="details-grid__item">
          <dt><strong i18n="@@ShowDetailsHandBaggage">Hand baggage</strong>:</dt>
          <dd>
            @if (flightDetails?.additional?.isHandBaggage >= 1) {
              <span i18n="@@ShowDetailsHandBaggageYes">Yes</span>
            } @else {
              <span i18n="@@ShowDetailsHandBaggageNo">No</span>
            }
          </dd>
        </div>
        <!-- Row 3: Operated by | Class -->
        @if (originalJourney?.operatingCarrierName) {
          <div class="details-grid__item">
            <dt><strong i18n="@@flightBasketOperatedBy">Operated by:</strong></dt>
            <dd>
              {{ originalJourney.operatingCarrierName }}
              @if (originalJourney?.bookingCode || originalJourney?.cabinCode) {
                ({{ originalJourney?.bookingCode || originalJourney?.cabinCode }})
              }
            </dd>
          </div>
        }
        <div class="details-grid__item">
          <dt><strong i18n="@@carsClass">Class</strong>:</dt>
          <dd>
            {{
              flightDetails.additional?.mixedCabinClass || flightDetails.cabinClass
                | splitCamelCase
                | translate
            }}
            @if (flightDetails?.fareInfo?.title && !flightDetails.additional?.mixedCabinClass) {
              <span>({{ flightDetails.fareInfo.title }})</span>
            }
            @if (!isMyBooking) {
              <a
                tabindex="0"
                role="button"
                class="fare_rules_link"
                (click)="openFareRules.emit()"
                (keydown.enter)="openFareRules.emit()"
                aria-label="Fare rules"
                i18n-aria-label
              >
                <i class="currency_info_icon" aria-hidden="true"></i>
              </a>
            }
          </dd>
        </div>
      </dl>
      <dl>
        @if (flightDetails.additional) {
          @if (
            flightDetails.additional.seat?.length ||
            flightDetails.additional.reducedMobillityAssistance?.length ||
            displayFlightExtras.length ||
            displayAdvancedAncillaryOptions.length ||
            displayBaggageAllowance.length
          ) {
            <div style="padding-top: 0.5rem">
              <strong i18n="@@ShowDetailsAddedExtras"><u>Added Extras</u></strong>
              @if (flightDetails.additional.seat?.length) {
                <div>
                  <dt><strong i18n="@@ShowDetailsSeat">Seat:</strong></dt>
                  <dd>
                    @for (seat of flightDetails.additional.seat; track seat; let last = $last) {
                      <span
                        >{{ seat.row }}{{ seat.column }}
                        @if (!last) {
                          <span>,</span>
                        }
                      </span>
                    }
                  </dd>
                </div>
              }
              @if (flightDetails.additional.reducedMobillityAssistance?.length) {
                <div>
                  <dt>
                    <strong i18n="@@ShowDetailsReducedMobillityAssistance"
                      >Reduced Mobillity Assistance:</strong
                    >
                  </dt>
                  <dd>
                    @for (
                      reducedMobillityAssistance of flightDetails.additional
                        .reducedMobillityAssistance;
                      track reducedMobillityAssistance;
                      let last = $last
                    ) {
                      <span>
                        {{ reducedMobillityAssistance.text }}
                        @if (!last) {
                          <span>,</span>
                        }
                      </span>
                    }
                  </dd>
                </div>
              }
              @if (displayFlightExtras.length) {
                <div>
                  <dt><strong i18n="@@ShowDetailsFlightExtras">Flight Extras:</strong></dt>
                  <dd>
                    @for (
                      flightExtras of displayFlightExtras;
                      track flightExtras;
                      let last = $last
                    ) {
                      <span>
                        {{ flightExtras.text }}
                        @if (!last) {
                          <span>,</span>
                        }
                      </span>
                    }
                  </dd>
                </div>
              }
              @if (displayAdvancedAncillaryOptions.length) {
                <div>
                  <dt>
                    <strong i18n="@@ShowDetailsAdvancedAncillaryOptions"
                      >Advanced Ancillary Options:</strong
                    >
                  </dt>
                  <dd>
                    @for (
                      advancedAncillaryOptions of displayAdvancedAncillaryOptions;
                      track advancedAncillaryOptions;
                      let last = $last
                    ) {
                      <span>
                        {{ advancedAncillaryOptions.text }}
                        @if (!last) {
                          <span>,</span>
                        }
                      </span>
                    }
                  </dd>
                </div>
              }
              @if (displayBaggageAllowance.length) {
                <div>
                  <dt><strong i18n="@@ShowDetailsLuggageOptions">Luggage Options:</strong></dt>
                  <dd>
                    @for (
                      baggageAllowance of displayBaggageAllowance;
                      track baggageAllowance;
                      let last = $last
                    ) {
                      <span>
                        {{ baggageAllowance.text }}
                        @if (!last) {
                          <span>,</span>
                        }
                      </span>
                    }
                  </dd>
                </div>
              }
            </div>
          }
        }
      </dl>
    </div>
  }
</div>
